'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setMinDate(age) {
  return (0, _moment2.default)().subtract({ years: age }).add({ days: 1 });
}

function getMaxEffectiveDate(allApplicants, age) {
  var dobs = allApplicants.map(function (applicant) {
    return (0, _moment2.default)(applicant.dob);
  });
  var max = _moment2.default.max(dobs);

  return _moment2.default.min([(0, _moment2.default)().add({ days: 364 }), max.add({ years: age }).subtract({ days: 1 })]);
}

function getMinExpiryDate(formValues) {
  return formValues.application.effective_date ? (0, _moment2.default)(formValues.application.effective_date).add(1, 'day') : (0, _moment2.default)().add(1, 'day');
}

function getMaxExpiryDate(formValues) {
  return formValues.application.effective_date ? (0, _moment2.default)(formValues.application.effective_date).add(364, 'day') : (0, _moment2.default)().add(364, 'day');
}

/** [
 * Calculates data related to the date fields on a form.
 * @param {Object} formValues - The values in the form.
 * @returns {Object} Object containing restrictions on the date fields.
 */

exports.default = function (formValues) {
  return (// confirm these values
    {
      applicants: {
        dob: {
          min: setMinDate(27),
          max: (0, _moment2.default)().subtract(6, 'months')
        }
      },
      application: {
        effective_date: {
          min: (0, _moment2.default)(),
          max: getMaxEffectiveDate(formValues.applicant, 27)
        },
        expiry_date: {
          min: getMinExpiryDate(formValues),
          max: getMaxExpiryDate(formValues)
        }
      }
    }
  );
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/student-accident/dates.js
// module id = 1740
// module chunks = 0